










































































  import { Component, Emit, Model, Prop, Vue } from "vue-property-decorator";

  @Component({
    name      : "FileDrop",
    components: {}
  })
  export default class FileDrop extends Vue {
    @Prop({
      required: true
    })
    private name!: string;
    @Prop({default: true})
    private enabled!: boolean;
    @Prop({
      type   : String,
      default: "true"
    })
    private accept!: string;
    @Prop({
      type   : String,
      default: "#9AE2E2"
    })
    private color!: string;

    @Prop({
      default: ""
    })
    private label!: string;
    @Model("filesAdded")
    private file!: File;

    private hightlight  = false;
    private previewData = "";

    openFileSelection(): void {
      if (!this.enabled) return;
      (this.$refs.fileInput as HTMLElement).click();
    }

    onDragOver(event: DragEvent): void {
      if (!this.enabled) return;
      event.preventDefault();
      this.hightlight = true;
    }

    onDragLeave(event: DragEvent): void {
      this.hightlight = false;
    }

    onDrop(event: DragEvent): void {
      if (!this.enabled) return;
      event.preventDefault();
      if (!event.dataTransfer)
        return;
      const files = event.dataTransfer.files;
      this.generatePreview(files);
      this.onFilesAdded(files);
      this.hightlight = false;
    }

private showError=false;
    onFileChanged(event: Event): void {
      console.log("onFileChanged")
      let files: FileList = (event.target as HTMLInputElement).files || new FileList();
      if(files.length==0){
        this.showError=true;
        return;
      } else {
        this.showError=false;
      }
      this.generatePreview(files);
      this.onFilesAdded(files);
    }

    @Emit("filesAdded")
    private onFilesAdded(files: FileList): unknown {
      // let result: File[] = [];
      // for (var i = 0; i < files.length; i++) {
      //   result.push(files.item(i) as File);
      // }
      return files.item(0) as File; // result;
    }

    private generatePreview(files: FileList): void {
      console.log(files);
      if (files && files[0]) {
        console.log(files[0]);
        var reader    = new FileReader();
//let imagePreview = this.$refs.imagePreview as Vue;
        reader.onload = (e) => {

          console.log(e?.target?.result);
          this.previewData = (e?.target?.result as string) || "";
          //imagePreview.$el.setAttribute('src',(e?.target?.result as string)||"")
        };

        reader.readAsDataURL(files[0]); // convert to base64 string
      }
    }
  }
